module.exports = __webpack_public_path__ + "static/media/surprise-party.37d12db6.svg";